




















































import Vue, { PropType } from 'vue';
import CloseIcon from '@/assets/icons/CloseIcon.vue';
import { Photos, User } from '@/types';
import { defaultHomeImage } from '@/util/homes';
import { uploadHomeProfilePhoto } from '@/api/photos'
import store from '@/store';
import { hideLoader, showLoader } from '@/util';
import { ActionType, EventType } from '@/constants/enums';
import { mapGetters } from 'vuex';
import { bus } from '@/main';

export default Vue.extend({
  name: 'ImageSelector',
  components: {
    CloseIcon
  },
  data () {
    return {
      isSelected: -1,
      uploadImageFailed: false
    }
  },
  props: {
    photos: {
      type: Array as PropType<Photos[]>,
      required: true
    },
    jobId: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(['isLoggedInAsAdmin'])
  },
  methods: {
    onImageError (event: Event) {
      (event.target as HTMLImageElement).src = defaultHomeImage();
    },
    markSelected (idx: number) {
      this.uploadImageFailed = false;
      this.isSelected = idx;
    },
    async uploadProfileImage () {
      if (this.isLoggedInAsAdmin) {
        bus.$emit(EventType.VIEW_VERSION);
        this.$emit('toggleImageSelector', false);
      } else {
        const updatedByEmail = store.getters.user.email;
        const buyerIds = store.getters.selectedJobBuyers.map((buyer: User) => buyer.email);
        if (this.isSelected >= 0 && updatedByEmail) {
          const imageUrl = this.photos[this.isSelected].assetValue;
          uploadHomeProfilePhoto({
            jobId: this.jobId,
            updatedByEmail,
            imageUrl,
            buyerIds
          }).then((response) => {
            if (response.message) {
              const homeDetail = store.getters.jobDetails;
              homeDetail.elevationImage = imageUrl;
              this.$store.dispatch(ActionType.SET_JOB_DETAILS, homeDetail);
              this.$emit('toggleImageSelector', false);
            } else {
              this.uploadImageFailed = true;
            }
          }).catch(() => {
            this.uploadImageFailed = true;
          });
        }
      }
    }
  }
});
